import { TrustBanner } from 'components/TrustBanners/TrustBanner';

/**
 * This component is a placeholder for the TrustBanner component to be able to link it via Contentful.
 */
export function TrustBannerLink() {
  // Note, the trustbanner has no container on this level as the version on mobile is full width
  // but the desktop one is in a container.
  return <TrustBanner title="Über 300.000 zufriedene Kunden seit 2007" />;
}
